module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/door/texture.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/door/texture.png
// module id = 478
// module chunks = 0